webpackJsonp([184662623972074],{

/***/ 467:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"title":"Contact Us","subtitle":"We'd Love To Help You, Feel Free To Drop A Mail","meta_title":"Contact Us | Gatsby Starter Business","meta_description":"Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Sed posuere consectetur est at lobortis. Cras mattis consectetur purus sit amet fermentum.","heading":null,"contacts":[{"email":"ineedacar@lorem.com","description":"Want to get started with the service?  Send an email to us here, and we will promptly get you started!"},{"email":"marketing@lorem.com","description":"Looking to advertise using our platform?  Please send your details here, and we will promptly get back to you."}]}}},"pathContext":{"id":"/opt/build/repo/src/pages/contact/index.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---contact-c262a3d57539ed943739.js